<template>
    <div>
        <div class="flex items-center justify-between mb-8">
            <h2 class="text-2xl font-medium">
                <div v-if="!total">Комментарии</div>
                <div v-else>{{ plural(total, ['комментарий', 'комментария', 'комментариев']) }}</div>
            </h2>

            <div class="flex items-center space-x-3 relative">
                <post-subscribe :subscribed="subscribed" :postid="postid"></post-subscribe>

                <svg-icon
                    @click="opened = !opened"
                    icon="sliders"
                    title="Выбрать порядок сортировки комментариев"
                    :class="{'stroke-black dark:stroke-white': opened}"
                    class="cursor-pointer w-4 h-4 opacity-50 hover:opacity-100"
                ></svg-icon>

                <div v-click-outside="closeSort" v-if="opened"
                     class="z-10 flex w-40 flex-col absolute mt-4 bg-white dark:bg-slate-900 shadow rounded-xl space-y-1 top-full right-0 p-2">
                    <div @click="setSort('popular')"
                         :class="{'bg-gray-100 dark:bg-slate-600 font-semibold': sort === 'popular'}"
                         class="p-2 cursor-pointer rounded text-gray-700 dark:text-gray-300 py-1">
                        Лучшие
                    </div>
                    <div @click="setSort('last')"
                         :class="{'bg-gray-100 dark:bg-slate-600 font-semibold': sort === 'last'}"
                         class="p-2 cursor-pointer rounded text-gray-700 dark:text-gray-300 py-1">
                        Последние
                    </div>
                </div>
            </div>
        </div>

        <div v-if="loading"
             class="rounded-md p-2 bg-gray-100 dark:bg-gray-700 dark:text-gray-300 text-center text-gray-500">
            Паддажи, ебана
        </div>

        <comment-form
            v-if="user.check() && showForm && total > 5 && !loading"
            @commentAdded="addComment($event, true)"
            :compact="true"
            :postid="postid"
            parent_id="0"
            class="mb-12"></comment-form>

        <div v-if="!loading" class="space-y-6 relative">
            <div v-if="!comments[0]"
                 class="rounded-md p-2 bg-gray-100 text-center dark:bg-gray-700 dark:text-gray-300 text-gray-500">
                Комментариев еще нет. Будь первым!
            </div>

            <div v-if="pinned.length">
                <comment v-for="comment in pinned"
                         :key="comment.id + ':' + sort"
                         :comment="comment"
                         :comments="[]"
                         :postid="postid"
                         :userid="userid"
                         :short="1"
                         :pinned="1"
                         :rate="1"
                         @commentAdded="addComment($event)"
                         @commentUpdated="updateComment"
                ></comment>
            </div>

            <div class="flex space-x-2">
                <div class="flex-1 min-w-0">
                    <comment v-for="comment in comments[0]"
                             :key="comment.id + ':' + sort"
                             @commentAdded="addComment($event)"
                             :comment="comment"
                             :comments="comments"
                             :postid="postid"
                             :userid="userid"
                             :reply_to="reply_to"
                             @toggleReply="toggleReply($event)"
                             @closeForm="reply_to = null"
                             @mediaLoaded="incrementMediaLoaded"
                             @commentUpdated="updateComment"
                             :is-new="isNew(comment)"
                    ></comment>
                </div>

                <div class="hidden md:block md:w-10 shrink-0">
                    <div v-if="newComments.length" @click="appendNewComment" class="sticky top-1/2">
                        <div
                            class="w-12 h-12 flex border border-gray-200 dark:border-slate-500 items-center shadow-xl cursor-pointer justify-center rounded-full bg-white dark:bg-slate-700 relative">
                            <div
                                class="leading-none p-1 px-2 absolute bg-orange text-white text-xs font-medium -left-2 -top-2 rounded-2xl">
                                {{ newComments.length }}
                            </div>
                            <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                 fill="currentColor" viewBox="0 0 16 16">
                                <path fill-rule="evenodd"
                                      d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"/>
                            </svg>
                        </div>
                    </div>
                </div>

                <div v-if=" newComments.length"
                     class="md:hidden fixed bottom-[calc(60px+env(safe-area-inset-bottom))] left-0 right-0 flex justify-center z-100">
                    <div @click="appendNewComment"
                         class="ring ring-orange/30 dark:ring-white/30 cursor-pointer mx-auto rounded-3xl text-xs bg-white dark:bg-slate-600 p-1 px-3 shadow-lg">
                        {{
                            plural(newComments.length, ['новый комментарий', 'новых комментария', 'новых комментариев'])
                        }}
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-12">
            <comment-form
                v-if="user.check() && showForm"
                @commentAdded="addComment($event)"
                :postid="postid"
                parent_id="0"
                @focus="toggleReply(null)"
            ></comment-form>
        </div>
    </div>
</template>
<script>
import {notify} from "@kyvg/vue3-notification";
import Textarea from "../form/textarea";
import Comment from "./Comment";
import UploadImage from "./../partials/uploadImage";
import CommentForm from "./CommentForm";
import Client from "../../js/modules/Client";
import User from "../../js/modules/User";
import PostSubscribe from "./PostSubscribe.vue";
import Urls from "../../js/modules/Urls";
import {CommentStore} from "../../js/stores/CommentStore";
import CommentScroller from "../../js/modules/CommentScroller";
import PostView from "../../js/modules/PostView";

export default {
    components: {PostSubscribe, CommentForm, Comment, Textarea, UploadImage},
    methods: {
        appendNewComment() {
            let comment = this.newComments.shift();
            let parent_id = this.getCommentParentIdKey(comment);

            if (!this.comments[parent_id]) {
                this.comments[parent_id] = [];
            }

            this.comments[parent_id].push(comment);

			this.$emit('commentsCountUpdated', this.total);

            setTimeout(() => {
                CommentScroller(document.querySelector('#comment-' + comment.id));
            }, 300);
        },
        closeSort() {
            this.opened = false;
        },
        setSort(sort) {
            if (sort === this.sort) {
                return;
            }

			this.sort = sort;
            this.loading = true;

			Client.patch('/api/v1.1/posts/' + this.postid + '/comments', {
                sort: this.sort,
            }).then(response => {
                this.loading = false;
                this.load();
            }).catch(error => {
                notify({
                    type: 'error',
                    text: 'Не получилось. Пусть останется так'
                });
                this.loading = false;
            });
        },
        toggleReply(comment_id) {
            if (this.store.data === null) {
                this.store.setParent(comment_id);
            } else {
                if (this.store.data === comment_id) {
                    this.store.setParent(null);
                } else {
                    this.store.setParent(comment_id);
                }
            }
        },
        updateComment(comment) {
            let parent_id = this.getCommentParentIdKey(comment);
            let commentIndex = this.getCommentIndex(comment);
            this.comments[parent_id][commentIndex] = comment;
        },
        isNew(comment) {
            if (this.lastPostViewTime) {
                let lastSeenTime = new Date(this.lastPostViewTime).getTime();
                let commentTime = new Date(comment.date).getTime();
                return commentTime > lastSeenTime;
            }

            return false;
        },
        updateCommentRating(comment) {
            let parent_id = this.getCommentParentIdKey(comment);
            let commentIndex = this.getCommentIndex(comment);
            this.comments[parent_id][commentIndex].rate = comment.rate;
        },
        getCommentParentIdKey(comment) {
            return comment.parent_comment_id ? comment.parent_comment_id : 0;
        },
        getCommentIndex(comment) {
            let commentIndex = 0;
            let parent_id = this.getCommentParentIdKey(comment);
            if (!this.comments[parent_id]) {
                return 0;
            }
            this.comments[parent_id].forEach((commentItem, index) => {
                if (comment.id === commentItem.id) {
                    commentIndex = index;
                }
            });
            return commentIndex;
        },
        addComment(comment, top = false) {
            let parent_id = this.getCommentParentIdKey(comment);

            if (!this.comments[parent_id]) {
                this.comments[parent_id] = [];
            }

            if (top) {
                this.comments[parent_id] = [comment, ...this.comments[parent_id]];
            } else {
                this.comments[parent_id].push(comment);
            }

            this.store.setParent(null);
        },
        load() {
            if (!this.loading) {
                this.loading = true;
                Client.get('/api/v1.1/posts/' + this.postid + '/comments')
                    .then(response => {
                        this.comments = response.data.data;

                        // считаем общее число медиафайлов
                        for (const [commentParentId, comments] of Object.entries(this.comments)) {
                            comments.forEach(comment => {
                                comment.images.forEach(url => {
                                    if (Urls.isImage(url)) {
                                        this.medias.push(url);
                                    }
                                });
                            });
                        }

                        setTimeout(() => {
                            this.scrollToAnchor();
                        }, 300);

                        this.loading = false;
                    })
                    .catch(error => {
                        notify({
                            type: 'error',
                            text: 'Ну не шмогла я загрузить комменты'
                        });
                        this.loading = false;
                    });
            }
        },
        plural(count, words) {
            let cases = [2, 0, 1, 1, 1, 2];
            return count + ' ' + words[(count % 100 > 4 && count % 100 < 20) ? 2 : cases[Math.min(count % 10, 5)]];
        },
        scrollToAnchor() {
            if (this.scrolledToAnchor) {
                return;
            }

            let anchor = window.location.hash;
            if (anchor && anchor.length > 1) {
                CommentScroller(document.querySelector(anchor));
            }

        },
        incrementMediaLoaded() {
            // Когда медиафайл загружен - он вызовет событие, которое дернет этот метод
            this.mediaLoaded++;

            // Когда количество загруженных ресурсов сравнялось с общим числом медиафайлов - прокручиваем к якорю
            if (this.mediaLoaded === this.totalMedia) {
                this.scrollToAnchor();
            }
        },
        cleanupLocalStorageExpiredValues() {
            let now = new Date();
            now.setMonth(-1);
            let monthAgoTime = now.getTime();
            Object.keys(localStorage).forEach((key) => {
                if (key.includes(PostView.keyPrefix)) {
                    let value = localStorage.getItem(key);
                    let commentTime = new Date(value).getTime();
                    let isExpired = commentTime < monthAgoTime;
                    if (isExpired) {
                        localStorage.removeItem(key);
                    }
                }
            });
        }
    },
    props: [
        'showForm',
        'postid',
        'userid',
        'sortby',
        'disableRating',
        'subscribed',
    ],
    data() {
        return {
            lastPostViewTime: PostView.lastViewed(this.postid),
            store: new CommentStore(),
            user: new User(),
            loading: false,
            reply_to: null,
            opened: false,
            sort: this.sortby ?? 'last',
            form: {
                parent_id: null,
                body: '',
                image: null,
            },
            comments: [],
            newComments: [],
            medias: [],
            totalMedia: 0,
            mediaLoaded: 0,
            scrolledToAnchor: false,
        }
    },
    mounted() {
        this.load();

        Echo.private('post.' + this.postid)
            .listen('.CommentAdded', e => {
                let ignored = this.user.isCommentsIgnoredForUser(e.comment.user_id);
                if (e.comment.user_id !== this.user.id() && !ignored) {
                    this.newComments.push(e.comment);
                }
            })
            .listen('.CommentUpdated', e => {
                let ignored = this.user.isCommentsIgnoredForUser(e.comment.user_id);
                if (!ignored) {
                    this.updateComment(e.comment);
                }
            })
            .listen('.CommentRated', e => {
                let ignored = this.user.isCommentsIgnoredForUser(e.comment.user_id);
                if (!ignored) {
                    this.updateCommentRating(e.comment);
                }
            })
        ;

        window.addEventListener("beforeunload", () => {
            PostView.postClosed(this.postid);
        });

        this.cleanupLocalStorageExpiredValues();
    },
    computed: {
        pinned() {
            let pinned = [];

            Object.keys(this.comments).forEach(key => {
                this.comments[key].forEach(comment => {
                    if (comment.is_pinned) {
                        pinned.push(comment);
                    }
                });
            });

            return pinned;
        },
        total() {
            let nonDeletedComments = Object.values(this.comments).map(items => {
                return Object.values(items).filter(comment => !comment.is_deleted).length;
            });

            return nonDeletedComments.length
                ? nonDeletedComments.reduce((a, b) => a + b)
                : 0;
        }
    },
}
</script>
